import { MDSIconKind } from "@/mds/components/icon";
import { IMDSDialogProps, MDSDialogSlotName } from "@/mds/components/overlays/dialog/dialog.types";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";
import {
  StyledDialog,
  StyledDialogBody,
  StyledDialogHeader,
  StyledDialogFooter,
  StyledButtonsLeft,
  StyledButtonsRight,
  StyledExitButton,
} from "@/mds/components/overlays/dialog/dialog.styles";

export const MDSDialog = ({
  children,
  isDismissable = true,
  handleClose,
  fluidWidth,
}: IMDSDialogProps) => {
  const header = getSlot(children, MDSDialogSlotName.Header);
  const content = getSlot(children, MDSDialogSlotName.Content);
  const defaultChildren = getUnslottedChildren(children);

  const footer = getSlot(children, MDSDialogSlotName.Footer);
  const buttonsLeft = getSlot(children, MDSDialogSlotName.ButtonsLeft);
  const buttonsRight = getSlot(children, MDSDialogSlotName.ButtonsRight);
  const hasFooter = footer || buttonsLeft || buttonsRight;

  return (
    <StyledDialog
      className="mds-dialog"
      aria-label="MDS Dialog"
      data-mds-name="dialog"
      $fluidWidth={fluidWidth}
    >
      {(!!header || isDismissable) && (
        <StyledDialogHeader>
          {header}
          {isDismissable && (
            <StyledExitButton
              onClick={handleClose}
              iconKind={MDSIconKind.Exit}
              aria-label="Close"
            />
          )}
        </StyledDialogHeader>
      )}
      <StyledDialogBody>{content || defaultChildren}</StyledDialogBody>
      {hasFooter && (
        <StyledDialogFooter>
          {footer || (
            <>
              {buttonsLeft && <StyledButtonsLeft>{buttonsLeft}</StyledButtonsLeft>}
              {buttonsRight && <StyledButtonsRight>{buttonsRight}</StyledButtonsRight>}
            </>
          )}
        </StyledDialogFooter>
      )}
    </StyledDialog>
  );
};
